import { atom } from 'recoil';

type DateRange = {
  startDate: string | null;
  endDate: string | null;
};

export const soCouponDateRangeState = atom<DateRange>({
  key: 'soCouponDateRangeState',
  default: { startDate: null, endDate: null }
});